import { c as _c } from "react/compiler-runtime";
import { useFetcher } from "@website/fetcher/use-fetcher/use-fetcher";
import { useLoginStatus } from "@website/hooks/auth-manager";
import { fetchInstalmentWallet } from "./index.services";
export function useInstalmentWallet() {
  const $ = _c(5);
  const {
    isLoggedIn
  } = useLoginStatus();
  let t0;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t0 = ["installmentWallet"];
    $[0] = t0;
  } else {
    t0 = $[0];
  }
  let t1;
  if ($[1] !== isLoggedIn) {
    t1 = {
      enabled: isLoggedIn,
      retry: false,
      queryKey: t0,
      queryFn: _temp
    };
    $[1] = isLoggedIn;
    $[2] = t1;
  } else {
    t1 = $[2];
  }
  const {
    data: installmentWallet
  } = useFetcher(t1);
  let t2;
  if ($[3] !== installmentWallet) {
    t2 = {
      installmentWallet
    };
    $[3] = installmentWallet;
    $[4] = t2;
  } else {
    t2 = $[4];
  }
  return t2;
}
function _temp() {
  return fetchInstalmentWallet();
}